import { render, staticRenderFns } from "./PrimeCompletePopup.vue?vue&type=template&id=35a90bc8&scoped=true"
import script from "./PrimeCompletePopup.vue?vue&type=script&lang=js"
export * from "./PrimeCompletePopup.vue?vue&type=script&lang=js"
import style0 from "./PrimeCompletePopup.vue?vue&type=style&index=0&id=35a90bc8&prod&lang=scss&scoped=true"
import style1 from "./PrimeCompletePopup.vue?vue&type=style&index=1&id=35a90bc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a90bc8",
  null
  
)

export default component.exports